import type { Address } from 'app/types/address';
import type { Group } from 'app/types/group';
import type { FindAllListingsDTO, TransactionMode } from 'app/types/listing';
import { ListingType } from 'app/types/listing';
import type { Language } from 'app/lib/language';

export function normalizeListingFilters(
  filters: FindAllListingsDTO & { isLoggedIn?: boolean; userLanguage?: Language },
  allGroups?: Group[],
  allAddresses?: Address[],
): FindAllListingsDTO & { isLoggedIn?: boolean; userLanguage?: Language } {
  filters.take ??= 25;
  filters.search ??= '';
  filters.doGrouping = true;

  if (!filters.userId) {
    filters.groupIds ??= allGroups?.map((group) => group.id) ?? [];
    filters.addressIds ??= allAddresses?.map((address) => address.id) ?? [];
    filters.groupIds = [...filters.groupIds].sort((left, right) => left.localeCompare(right));
    filters.addressIds = [...filters.addressIds].sort((left, right) => left.localeCompare(right));
  }

  return filters;
}

type MyListingsFilters = FindAllListingsDTO & { isLoggedIn: boolean };

export const getMyListingsRequestsFilters = (
  isLoggedIn: boolean,
  userId?: string,
  take?: number,
): MyListingsFilters => ({
  type: ListingType.request,
  userId,
  isLoggedIn,
  take: take ?? 100,
  includeCounts: true,
  __counter: 0,
});

export const getMyListingsOffersFilters = (
  isLoggedIn: boolean,
  userId?: string,
  take?: number,
  transactionMode?: TransactionMode,
): MyListingsFilters => ({
  type: ListingType.offer,
  userId,
  isLoggedIn,
  take: take ?? 100,
  includeCounts: true,
  transactionMode,
  __counter: 0,
});

export const getMyListingsCountFilters = (
  isLoggedIn: boolean,
  userId: string | undefined,
  type: ListingType,
): MyListingsFilters => ({
  type,
  userId,
  isLoggedIn,
  take: 1,
  includeCounts: true,
  __counter: 0,
});
